import { api } from 'app/api';

/**
 * @param { hspId:string, usrId:string, hsptlzRsvNo:string } params
 * @returns I-14-1 비급여 데이터
 */
export const getNoBenefitInfo = async (params) => {
  return await api.get(`dfd/api/if/web/v1/hsptlz-form-sign-non-benefit-info`, {
    params,
  });
};
